import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

// Shown in place of the testimonials until real customer reviews are added to data/testimonials.ts
const benefits = [{
  title: 'Clear visual explanations',
  text: 'Make current flow, Ohm’s law, switching layouts, motor control logic and schematic symbols easy to explain and easy for students to remember.'
}, {
  title: 'Six organized volumes',
  text: '300 visual training pages across every core electrical teaching area, from circuit theory and residential wiring to motors, troubleshooting and PLCs, so class prep takes minutes instead of hours.'
}, {
  title: 'Safety & standards built in',
  text: 'PPE, lockout/tagout and test-before-touch routines, NEC and IEC examples labeled side by side, step-by-step sequences and ❌/✅ comparisons that reinforce safe, correct work.'
}, {
  title: 'Ready-to-use drills & assessments',
  text: 'Lab drills, circuit-building activities, wiring exercises, quick checks and competency rubrics that keep students engaged and progressing.'
}];
export function InstructorBenefits() {
  return <section className="py-12 bg-[#F3F6FC] border-y border-[#D2DCEC]" data-id="element-174" data-mp="1en7v8qs9loq9">
      <div className="max-w-7xl mx-auto px-4" data-id="element-175" data-mp="1sm7k9zjow5my">
        <div className="text-center mb-7" data-id="element-176" data-mp="1ojawlufaljc5">
          <h2 className="text-[#0B1F4D] font-bold tracking-widest uppercase text-sm" data-id="element-177" data-mp="1oi9lxr26uyuy">
            Why Electrical Instructors Choose This Atlas
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178" data-mp="1xk8zg9dzvkt5">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-[#D2DCEC] p-6 rounded-2xl shadow-sm shadow-[#0B1F4D]/5 flex flex-col" data-id="element-179" data-mp="2c7lr8fueamrz" data-mpi={index}>
              <CheckCircle2 size={22} className="text-green-600 mb-3" aria-hidden="true" data-id="element-180" data-mp="1dydonpoc0mh5" />
              <h3 className="font-bold text-[#0B1F4D] text-base mb-2" data-id="element-181" data-mp="1iwf9af1eotuq">{benefit.title}</h3>
              <p className="text-slate-700 text-sm leading-relaxed" data-id="element-182" data-mp="1mwpf9rp77k9l">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}